import React from 'react';
import Icon from '../../../components/AppIcon';

const RoutingRulesTable = ({ rules }) => {
  const conditionTypeLabels = {
    salary_threshold: 'Salary Threshold',
    department: 'Department',
    amount_threshold: 'Amount Threshold',
    leave_type: 'Leave Type',
    employee_level: 'Employee Level'
  };

  const formatConditionValue = (type, value) => {
    if (type === 'salary_threshold' || type === 'amount_threshold') {
      return `≥ K${value?.min_salary || value?.min_amount || 0}`;
    }
    if (type === 'department') {
      return value?.department || 'N/A';
    }
    if (type === 'leave_type') {
      return value?.leave_type || 'N/A';
    }
    return JSON.stringify(value);
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-border">
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Rule Name</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Condition Type</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Condition Value</th>
            <th className="text-center py-3 px-4 text-sm font-semibold text-foreground">Priority</th>
            <th className="text-center py-3 px-4 text-sm font-semibold text-foreground">Status</th>
          </tr>
        </thead>
        <tbody>
          {rules?.map((rule) => (
            <tr key={rule?.id} className="border-b border-border hover:bg-muted/5">
              <td className="py-3 px-4 text-sm text-foreground">{rule?.ruleName}</td>
              <td className="py-3 px-4 text-sm text-muted-foreground">
                {conditionTypeLabels?.[rule?.conditionType] || rule?.conditionType}
              </td>
              <td className="py-3 px-4 text-sm text-foreground font-medium">
                {formatConditionValue(rule?.conditionType, rule?.conditionValue)}
              </td>
              <td className="py-3 px-4 text-center">
                <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-primary/10 text-primary text-sm font-semibold">
                  {rule?.priority}
                </span>
              </td>
              <td className="py-3 px-4 text-center">
                {rule?.isActive ? (
                  <span className="inline-flex items-center gap-1 px-2 py-1 bg-success/10 text-success text-xs rounded">
                    <Icon name="CheckCircle" size={12} />
                    Active
                  </span>
                ) : (
                  <span className="inline-flex items-center gap-1 px-2 py-1 bg-muted/10 text-muted-foreground text-xs rounded">
                    <Icon name="XCircle" size={12} />
                    Inactive
                  </span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {rules?.length === 0 && (
        <div className="text-center py-8 text-muted-foreground">
          <Icon name="AlertCircle" size={32} className="mx-auto mb-2 opacity-50" />
          <p>No routing rules configured</p>
        </div>
      )}
    </div>
  );
};

export default RoutingRulesTable;